import Sticky from "sticky-js";
let stickyMobile = new Sticky(".navigation-in-page", {
  marginTop: 106
});
let stickyDesktop = new Sticky(".navigation-secondary", {
  marginTop: 106
});

/********************************* Main Carousel *********************************/
import mainCarousel from "./scripts/main-carousel.js";
mainCarousel();

/********************************* Secondary Navigation *********************************/
import secondaryNavigation from "./scripts/secondary-navigation";
secondaryNavigation();